import { createContext, useContext, useEffect, useState } from 'react';
import { DBRequest, useConfig } from '../../api/api';

const EmailClient = createContext({
  preferences: null,
  updateSelectedFolder: () => {},
});

export const EmailClientProvider = ({ children }) => {
  const config = useConfig();
  const [apiData, setApiData] = useState(null);
  const [unseenCount, setUnseenCount] = useState(null);
  const [failedCount, setFailedCount] = useState(null);
  const [queuedCount, setQueuedCount] = useState(null);

  // update clock
  const updateInSeconds = 10;
  useEffect(() => {
    // INITIAL FETCH
    if (!apiData) fetchFolders();

    // Set an interval to fetch folders every `updateInSeconds` seconds
    const requestMails = setInterval(() => {
      if (apiData?.data.length > 0) fetchFolders();
    }, updateInSeconds * 1000);
    return () => clearInterval(requestMails);
  }, [config, apiData]);

  // Listen for standalone auth changes (re-login)
  useEffect(() => {
    const handleAuthChange = (event) => {
      if (event.detail?.authenticated && config) {
        // Small delay to ensure cookies are set
        setTimeout(() => {
          fetchFolders();
        }, 100);
      }
    };

    window.addEventListener('standaloneAuthChange', handleAuthChange);
    return () => window.removeEventListener('standaloneAuthChange', handleAuthChange);
  }, [config]);

  function fetchFolders() {
    if (!config) return;
    DBRequest({
      config,
      path: `email-credentials`,
      onResponse: handleResponse,
    });
  }

  function handleResponse(response) {
    setApiData(response);
    setUnseenCount(getUnseenCount(response.data));
    setFailedCount(sumCredentialField(response.data, 'failedEmailCount'));
    setQueuedCount(sumCredentialField(response.data, 'queuedEmailCount'));
  }

  function getUnseenCount(arrOfInboxes) {
    var count = 0;
    arrOfInboxes.forEach((element) => {
      const folders = element.inbox.folders;
      folders?.forEach((folder) => {
        if (folder.name === 'INBOX') count += folder.unseenCount;
      });
    });
    return count;
  }

  function sumCredentialField(credentials, field) {
    return credentials.reduce((sum, cred) => sum + (cred[field] || 0), 0);
  }

  return (
    <EmailClient.Provider
      value={{
        emailCredentials: apiData,
        setEmailCredentials: setApiData,
        fetchFolders,
        unseenCount,
        failedCount,
        queuedCount,
      }}
    >
      {children}
    </EmailClient.Provider>
  );
};

export const useEmailClient = () => useContext(EmailClient);
